import React, { useState, useEffect } from "react";
import { PaymentService, AuthService } from "../../services";
import { injectModels } from "../../redux/injectModels";
import { Button } from "react-bootstrap";
import { globalConstant } from "../../constants/globalConstant";
import Swal from "sweetalert2";
import { handleConsoleError } from "../../utils/common-methods";
import { toast } from "react-toastify";

const ManagePayment = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [linkAccountData, setLinkedAccountData] = useState(null);

  const fetchData = async () => {
    if (!loginUser) return;

    props.application.setLoading(true);
    try {
      const res = await PaymentService.getConnectedAccountByUserId(
        loginUser?.id
      );
      if (res?.isSuccess && res?.data) {
        setLinkedAccountData(res?.data);
      }
    } catch (error) {
      const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    } finally {
      props.application.setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handlePayment = async () => {
    try {
      props.application.setLoading(true);
      const res = await PaymentService.createConnetedAccount(loginUser?.id);
      if (res?.isSuccess) {
        if (res?.data) {
          const returnUrl = res?.data;
          window.location.href = returnUrl;
        }
        props.application.setLoading(false);
      } else {
        toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handledelete = async () => {
    const pinkColor = globalConstant.COLOR_PINK;
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: pinkColor,
      cancelButtonColor: "#373737",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await PaymentService.deleteConnetedAccount({
            Id: linkAccountData?.id,
          });
          if (res?.isSuccess) {
            if (res?.data) {
              setLinkedAccountData(null);
              await fetchData();
            }
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
          }
        } catch (error) {
          props.application.setLoading(false);
        }
      }
    });
  };

  return (
    <React.Fragment>
      <React.Fragment>
        <section className="edit-form-table">
          <div className="container mt-3">
            <div className="mb-3 mt-3">
              {linkAccountData && (
                <React.Fragment>
                  <div className="mb-3 mt-3">
                    Your linked stripe account to accepts payments are:
                  </div>
                  <p>
                    <strong>Stripe Account Id :</strong>{" "}
                    <span>{linkAccountData?.stripeAccountId}</span>
                  </p>

                  <p>
                    <strong>Account Type :</strong>{" "}
                    <span>{linkAccountData?.accountType}</span>
                  </p>

                  {linkAccountData?.capabilities &&
                    linkAccountData?.capabilities.length > 5 &&
                    Object.entries(
                      JSON.parse(linkAccountData?.capabilities)
                    ).map(([key, value]) => (
                      <p key={key}>
                        <strong>{key}:</strong> {value}
                      </p>
                    ))}
                  {!linkAccountData ||
                    ((!linkAccountData.payoutsEnabled ||
                      !linkAccountData.chargesEnabled) && (
                      <p className="text-danger  mb-3">
                        If your account is not active then please remove it and
                        setup again to use swallow platform.
                      </p>
                    ))}
                </React.Fragment>
              )}

              {!linkAccountData && (
                <React.Fragment>
                  <div className="mb-3 mt-3">
                    Please link your Stripe account to create events and accept
                    payments on the Swallow Platform
                  </div>
                  <div className="verifier-buttton1 mb-3">
                    <Button onClick={handlePayment}>Link Stripe Account</Button>{" "}
                  </div>
                </React.Fragment>
              )}
              {linkAccountData && (
                <React.Fragment>
                  <div className="verifier-buttton1 mb-3">
                    <Button onClick={handledelete}>
                      Remove Stripe Account
                    </Button>{" "}
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </section>
      </React.Fragment>
    </React.Fragment>
  );
};
export default injectModels(["auth", "application"])(ManagePayment);
